type SortableDeliveryPolicy = {
  id?: number
  name: string
}

export const sortDeliveryPolicies = (deliveryPolicies: SortableDeliveryPolicy[]): SortableDeliveryPolicy[] => {
  return deliveryPolicies.slice().sort((a, b) => {
    const isADefault = a.id === undefined
    const isBDefault = b.id === undefined

    // Prioritize the TrivialDeliveryPolicy, which has no id
    if (isADefault && !isBDefault) return -1
    if (!isADefault && isBDefault) return 1

    // Otherwise sort by name
    return a.name.localeCompare(b.name)
  })
}
